export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7g-8af8935bbc12c019e76bd87c2a08e9f1.webp";